import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cartSlice";

const saveToLocalStorage = (state) => {
  try {
    const cartData = state.cart.cartItems;
    localStorage.setItem("cartItems", JSON.stringify(cartData));
  } catch (e) {
    console.error("无法保存到 localStorage", e);
  }
};

const store = configureStore({
  reducer: {
    cart: cartReducer,
  },
});

// 监听 Redux 状态变化
store.subscribe(() => {
  saveToLocalStorage(store.getState());
});

export { store };
